export enum Color {
  //Default and Focus text/background colors always match
  //Disabled colors are universal
  PRIMARY_DEFAULT = '#0E7E75',
  PRIMARY_HOVER = '#006666',
  PRIMARY_ACTIVE = '#005252',
  PRIMARY_TEXT = '#FFFFFF',
  PRIMARY_FOCUS_BORDER = '#0000004C',

  SECONDARY_DEFAULT = '#FFFFFF',
  SECONDARY_DEFAULT_BORDER_AND_TEXT = '#0E7E75',
  SECONDARY_HOVER = '#EBF7F6',
  SECONDARY_HOVER_BORDER_AND_TEXT = '#006666',
  SECONDARY_ACTIVE = '#DAF1EF',
  SECONDARY_ACTIVE_BORDER_AND_TEXT = '#006666',

  TERTIARY_DEFAULT = '#FFFFFF',
  TERTIARY_DEFAULT_BORDER_AND_TEXT = '#787162',
  TERTIARY_HOVER = '#F9F8F5',
  TERTIARY_HOVER_BORDER_AND_TEXT = '#787162',
  TERTIARY_ACTIVE = '#EFEBE1',
  TERTIARY_ACTIVE_BORDER_AND_TEXT = '#70695C',

  DESTRUCTIVE_DEFAULT = '#FFFFFF',
  DESTRUCTIVE_DEFAULT_BORDER_AND_TEXT = '#C94436',
  DESTRUCTIVE_HOVER = '#FEF7F6',
  DESTRUCTIVE_HOVER_BORDER_AND_TEXT = '#C94436',
  DESTRUCTIVE_ACTIVE = '#FBE7E4',
  DESTRUCTIVE_ACTIVE_BORDER_AND_TEXT = '#B93F31',

  PILL_DEFAULT = '#FFFFFF',
  PILL_DEFAULT_BORDER = '#E4E2DB',
  PILL_HOVER = '#EBF7F6',
  PILL_HOVER_BORDER = '#0E7E75',
  PILL_ACTIVE = '#DAF1EF',
  PILL_ACTIVE_BORDER = '#0E7E75',
  PILL_FOCUS = '#FFFFFF',
  PILL_FOCUS_BORDER = '#0E7E75',
  PILL_TEXT = '#4A4844',

  TOUCHPOINT_DEFAULT = '#FFFFFF',
  TOUCHPOINT_DEFAULT_BORDER = 'transparent',
  TOUCHPOINT_HOVER = 'transparent',
  TOUCHPOINT_HOVER_BORDER = 'transparent',
  TOUCHPOINT_ACTIVE = 'transparent',
  TOUCHPOINT_ACTIVE_BORDER = 'transparent',
  TOUCHPOINT_FOCUS = 'transparent',
  TOUCHPOINT_FOCUS_BORDER = 'transparent',
  TOUCHPOINT_TEXT = '#4A4844',

  SELECTOR_DEFAULT = '#FFFFFF',
  SELECTOR_DEFAULT_BORDER = '#E4E2DB',
  SELECTOR_DEFAULT_TEXT = '#4A4844',
  SELECTOR_SELECTED = '#f0f9f8',
  SELECTOR_FOCUS_SHADOW = '#0E7E75',
  SELECTOR_SELECTED_BORDER_AND_TEXT = '#0E7E75',

  DISABLED = '#F0F0F0',
  DISABLED_TEXT = '#6B6B6B',
  DISABLED_BORDER = '#737373',

  TRANSPARENT = '#00000000',

  ZERO_05_BLACK_SHADOW = 'rgba(0,0,0,0.05)',
  ZERO_10_BLACK_SHADOW = 'rgba(0,0,0,0.1)',
  ZERO_15_BLACK_SHADOW = 'rgba(0,0,0,0.15)',
  PRIMARY_SECONDARY_SHADOW = 'rgba(14,126,117,0.5)',
  TERTIARY_SHADOW = 'rgba(120,113,98,0.4)',
  DESTRUCTIVE_SHADOW = 'rgba(201,68,54,0.4)',
  PILL_SHADOW = 'rgba(14,126,117,0.4)',
  TOUCHPOINT_SHADOW = ''
}
